import { styled } from '@/styled-system/jsx';

export const StyledContainer = styled('div', {
  base: {
    position: 'relative',
    margin: 'auto',
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  variants: {
    size: {
      sm: {
        maxWidth: '320px',
      },
      md: {
        maxWidth: '920px',
      },
      lg: {
        maxWidth: '1280px',
      },
      full: {
        maxWidth: 'none',
      },
    },
    slimPadding: {
      true: {
        xl: {
          paddingLeft: '8px',
          paddingRight: '8px',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
    slimPadding: false,
  },
});
